<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import listRecord from "./listRecord.vue";
import addRecord from "./addRecord.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: { listRecord, addRecord },
  data() {
    return {
      table: {
        mname: "copyAccounts",
        key: "id",
        url: {
          list: "/admin/system/paperType/list",
          //   del: "/admin/system/facility",
        },
        output: false,
      },
      menus: [
        {
          label: "抄张计费",
          name: "accounting_statement",
          auth: "",
        },
        {
          label: "抄张汇总",
          name: "copy_a_summary",
          auth: "",
        },
        {
          label: "纸张费率",
          name: "paperType_list",
          auth: "",
        },
      ],
      query: {},
      actions: [],
      filters: [
        // {
        //   label: "型号",
        //   KeyEnter: this.search,
        //   name: "facilityType",
        //   value: "",
        //   type: "input",
        // },
        // {
        //   label: "资产分类",
        //   name: "typeId",
        //   value: "",
        //   type: "select",
        //   KeyEnter: this.search,
        //   dropList: [],
        // },
        // {
        //   label: "资产选择",
        //   name: "facilityNum",
        //   value: "",
        //   type: "select",
        //   KeyEnter: this.search,
        //   dropList: [],
        // },
        // {
        //   label: "资产归属",
        //   name: "assetOwnership",
        //   KeyEnter: this.search,
        //   value: "",
        //   type: "input",
        // },
        // {
        //   label: "资产编号",
        //   KeyEnter: this.search,
        //   name: "assetNum",
        //   value: "",
        //   type: "input",
        // },
      ],
      tableCols: [
        {
          title: "纸张类型",
          key: "typeName",
          minWidth: 100,
          align: "center",
          tooltip: "true",
        },
        {
          title: "单价",
          minWidth: 150,
          align: "center",
          key: "rate",
          tooltip: "true",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            "edit",
            // (vm, h, currentRow, param) => {
            //   // let directives = [];
            //   return (
            //     <Button
            //       size="small"
            //       onClick={() => this.goAccountRecord(currentRow)}
            //       type="default"
            //       style={{
            //         border: "none",
            //         color: "#4991ff",
            //         marginLeft: "5px",
            //       }}
            //     >
            //       抄张
            //     </Button>
            //   );
            // },
          ],
        },
      ],
    };
  },
  created() {},
  methods: {
    handleEdit(row) {
      $utils.url.push({
        name: "paperType_edit",
        query: { action: "edit", kv: row.typeId },
      });
    },
  },
};
</script>
<style scoped></style>
